// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#invoice {
  position: fixed;
  top: -100rem;
  left: -100rem;
}
#invoice * {
  text-transform: none !important;
}

.order-invoice-grid {
  display: grid;
  grid-template-columns: 1fr 1.7fr;
  grid-template-rows: calc(1rem + 1rem) 2rem minmax(calc(24 * 1rem), auto) auto;
  grid-column-gap: calc(3 * 1rem);
  grid-row-gap: 2rem;
}

.ordr-receipt-container-we {
  height: 100vh;
  contain: content;
}

.A4Paper {
  width: 794px;
  height: 1123px;
  padding: 10rem 8rem 2rem 8rem;
}

.outline {
  outline: 1px solid black;
}

.A4-paper-container {
  line-height: 140%;
  font-size: 1rem;
}

.div1 {
  grid-area: 1/1/2/2;
  width: 100%;
  height: 100%;
}
.div1 img,
.div1 svg {
  width: 100%;
  translate: 0% -52%;
}

.div2 {
  border-top-style: solid;
  border-bottom-style: solid;
  border-color: #333333;
  border-width: 1.2px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.div2 > :last-child {
  font-weight: 500;
  text-align: right;
}

.ordr-invoice-header-title {
  display: flex;
  flex-direction: column-reverse;
  font-weight: 900;
  translate: 0 1rem;
  text-transform: none;
}

.ordr-invoice-section-title {
  font-weight: 600;
}

.div3 {
  grid-area: 2/1/3/3;
}

.div4 {
  grid-area: 3/1/4/3;
  border-top-style: solid;
  border-width: 1.2px;
}
.div4 > :last-child {
  padding-top: 2rem;
}

.ordr-time-container {
  padding-top: 1rem;
  display: grid;
  grid-template-columns: 1fr 1.7fr;
  grid-column-gap: calc(3 * 1rem);
  grid-row-gap: 0.5rem;
}
.ordr-time-container > :nth-child(1) {
  grid-area: 1/1/2/2;
  font-weight: 600;
  text-align: end;
}
.ordr-time-container > :nth-child(2) {
  font-weight: 600;
  grid-area: 1/2/2/3;
}
.ordr-time-container > :nth-child(2) > :last-child {
  padding-left: 1.2ch;
}
.ordr-time-container > :nth-child(3) {
  grid-area: 2/1/3/2;
  text-align: end;
}
.ordr-time-container > :nth-child(4) {
  grid-area: 2/2/3/3;
}
.ordr-time-container > :nth-child(4) > :last-child {
  padding-left: 1.2ch;
}

.ordr-time-container-space {
  display: grid;
  grid-template-columns: 1fr 0.52fr;
  grid-column-gap: calc(3 * 1rem);
  grid-row-gap: 0.5rem;
  text-align: end;
}

.ordr-invoice-right-space {
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 0.5rem;
  text-align: start;
  position: relative;
}

.ordr-dets-container {
  display: grid;
  grid-template-rows: minmax(1rem, auto);
  grid-template-columns: 1fr 1.7fr;
  grid-column-gap: calc(3 * 1rem);
  grid-row-gap: 0.5rem;
}
.ordr-dets-container.space {
  grid-template-columns: 1fr 0.52fr;
}
.ordr-dets-container.space > :nth-child(even) {
  text-align: end;
  width: 100%;
}
.ordr-dets-container.space .tax-price {
  display: flex;
  align-items: end;
  justify-content: end;
}
.ordr-dets-container > :nth-child(odd) {
  text-align: end;
}
.ordr-dets-container > .ordr-dets-container-div1 {
  grid-area: 1/1/2/2;
}
.ordr-dets-container > .ordr-dets-container-div2 {
  grid-area: 1/2/2/3;
}
.ordr-dets-container > .ordr-dets-container-div3 {
  grid-area: 2/1/3/2;
}
.ordr-dets-container > .ordr-dets-container-div4 {
  grid-area: 2/2/3/3;
}
.ordr-dets-container > .ordr-dets-container-div5 {
  grid-area: 3/1/4/2;
}
.ordr-dets-container > .ordr-dets-container-div6 {
  grid-area: 3/2/4/3;
}
.ordr-dets-container > .ordr-dets-container-div7 {
  grid-area: 4/1/5/2;
}
.ordr-dets-container > .ordr-dets-container-div8 {
  grid-area: 4/2/5/3;
  display: flex;
  flex-direction: column;
}
.ordr-dets-container > .ordr-dets-container-div9 {
  grid-area: 5/2/6/3;
}
.ordr-dets-container > .ordr-dets-container-div10 {
  grid-area: 6/1/7/2;
}
.ordr-dets-container > .ordr-dets-container-div11 {
  grid-area: 6/2/7/3;
}
.ordr-dets-container > .ordr-dets-container-div12 {
  grid-area: 7/1/8/2;
}
.ordr-dets-container > .ordr-dets-container-div13 {
  grid-area: 7/2/8/3;
}
.ordr-dets-container > .ordr-dets-container-div14 {
  grid-area: 8/1/9/2;
}
.ordr-dets-container > .ordr-dets-container-div15 {
  grid-area: 8/2/9/3;
}

.div5 {
  grid-area: 4/1/5/2;
}

.div6 {
  grid-area: 5/1/6/3;
  border-top-style: solid;
  border-width: 1.2px;
  padding-top: 1rem;
  display: grid;
  grid-template-columns: 1fr 0.6fr;
  column-gap: 1.5rem;
}

.div7 {
  grid-area: 6/1/7/3;
  display: grid;
  grid-template-columns: 1fr 0.6fr;
  column-gap: 1.5rem;
}

.div8 {
  grid-area: 7/1/8/3;
  display: grid;
  grid-template-columns: 1fr 0.6fr;
  column-gap: 1.5rem;
}

.div9 {
  grid-area: 8/1/9/3;
  display: grid;
  grid-template-columns: 1fr 0.6fr;
  column-gap: 1.5rem;
}

.ordr-brand-address {
  position: absolute;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  text-align: end;
  padding-bottom: 1rem;
  color: #333333;
  width: 100%;
}

.ordr-total-container {
  border-top-style: solid;
  border-bottom-style: solid;
  border-color: #333333;
  border-width: 1.2px;
  display: grid;
  grid-template-columns: 1fr 0.5fr;
  grid-column-gap: calc(3 * 1rem);
  grid-row-gap: 0.5rem;
  position: relative;
  translate: 0 calc(-2 * 0.5rem);
}
.ordr-total-container > * {
  padding: calc(0.75 * 0.5rem) 0;
}
.ordr-total-container > :first-child {
  font-size: 600;
  text-align: end;
}
.ordr-total-container {
  padding-right: 4px;
}

.tax-title-container {
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/Components/common/OrdrReceipt/OrdrReceipt.scss"],"names":[],"mappings":"AAYA;EACC,eAAA;EACA,YAAA;EACA,aAAA;AAXD;AAaC;EACC,+BAAA;AAXF;;AAoBA;EACC,aAAA;EACA,gCAAA;EACA,6EACC;EAED,+BAAA;EACA,kBAzBU;AAMX;;AAqBA;EACC,aAAA;EACA,gBAAA;AAlBD;;AAoBA;EACC,YAAA;EACA,cAAA;EACA,6BAAA;AAjBD;;AAmBA;EACC,wBAAA;AAhBD;;AAmBA;EACC,iBAAA;EACA,eAjDS;AAiCV;;AAmBA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;AAhBD;AAiBC;;EAEC,WAAA;EACA,kBAAA;AAfF;;AAkBA;EAGC,uBAAA;EACA,0BAAA;EACA,qBApEoB;EAsEpB,mBA7Dc;EA+Dd,aAAA;EACA,mBAAA;EACA,8BAAA;AAnBD;AAsBC;EACC,gBAAA;EACA,iBAAA;AApBF;;AAuBA;EACC,aAAA;EACA,8BAAA;EACA,gBAhFoB;EAiFpB,iBAAA;EACA,oBAAA;AApBD;;AAsBA;EACC,gBAvFkB;AAoEnB;;AAqBA;EACC,kBAAA;AAlBD;;AAoBA;EACC,kBAAA;EACA,uBAAA;EACA,mBAzFc;AAwEf;AAmBC;EACC,iBA7FS;AA4EX;;AAoBA;EACC,iBAnGU;EAqGV,aAAA;EACA,gCAAA;EACA,+BAAA;EACA,oBAvGU;AAqFX;AAoBC;EACC,kBAAA;EACA,gBA/GiB;EAgHjB,eAAA;AAlBF;AAoBC;EACC,gBAnHiB;EAoHjB,kBAAA;AAlBF;AAoBE;EACC,mBAAA;AAlBH;AAqBC;EACC,kBAAA;EACA,eAAA;AAnBF;AAqBC;EACC,kBAAA;AAnBF;AAoBE;EACC,mBAAA;AAlBH;;AAsBA;EACC,aAAA;EACA,iCAAA;EACA,+BAAA;EACA,oBArIU;EAsIV,eAAA;AAnBD;;AAsBA;EACC,aAAA;EACA,0BAAA;EACA,oBA5IU;EA6IV,iBAAA;EACA,kBAAA;AAnBD;;AAqBA;EACC,aAAA;EACA,sCAAA;EACA,gCAAA;EACA,+BAAA;EACA,oBArJU;AAmIX;AAoBC;EACC,iCAAA;AAlBF;AAoBE;EACC,eAAA;EACA,WAAA;AAlBH;AAqBE;EACC,aAAA;EACA,gBAAA;EACA,oBAAA;AAnBH;AAuBC;EACC,eAAA;AArBF;AAwBC;EACC,kBAAA;AAtBF;AAwBC;EACC,kBAAA;AAtBF;AAwBC;EACC,kBAAA;AAtBF;AAwBC;EACC,kBAAA;AAtBF;AAwBC;EACC,kBAAA;AAtBF;AAwBC;EACC,kBAAA;AAtBF;AAwBC;EACC,kBAAA;AAtBF;AAwBC;EACC,kBAAA;EACA,aAAA;EACA,sBAAA;AAtBF;AAwBC;EACC,kBAAA;AAtBF;AAwBC;EACC,kBAAA;AAtBF;AAwBC;EACC,kBAAA;AAtBF;AAwBC;EACC,kBAAA;AAtBF;AAwBC;EACC,kBAAA;AAtBF;AAwBC;EACC,kBAAA;AAtBF;AAwBC;EACC,kBAAA;AAtBF;;AAyBA;EACC,kBAAA;AAtBD;;AAwBA;EACC,kBAAA;EACA,uBAAA;EACA,mBA9Nc;EAgOd,iBAnOU;EAoOV,aAAA;EACA,gCAAA;EACA,kBAAA;AAtBD;;AAwBA;EACC,kBAAA;EAEA,aAAA;EACA,gCAAA;EACA,kBAAA;AAtBD;;AAwBA;EACC,kBAAA;EAEA,aAAA;EACA,gCAAA;EACA,kBAAA;AAtBD;;AAwBA;EACC,kBAAA;EAEA,aAAA;EACA,gCAAA;EACA,kBAAA;AAtBD;;AAyBA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,oBAAA;EACA,cA5QoB;EA8QpB,WAAA;AAvBD;;AA0BA;EACC,uBAAA;EACA,0BAAA;EACA,qBApRoB;EAsRpB,mBA7Qc;EA+Qd,aAAA;EACA,gCAAA;EACA,+BAAA;EACA,oBApRU;EAqRV,kBAAA;EAEA,8BAAA;AA1BD;AA2BC;EACC,8BAAA;AAzBF;AA2BC;EACC,cAhSiB;EAiSjB,eAAA;AAzBF;AAMA;EAqBC,kBAAA;AAxBD;;AA2BA;EACC,aAAA;EACA,sBAAA;AAxBD","sourcesContent":["$grid-template-columns: 1fr 1.7fr;\n$text-primary-color: #333333;\n$font-md: 1rem;\n$font-weight-md: 400;\n$font-weight-bold: 600;\n$font-weight-thick: 700;\n$font-weight-strong: 900;\n$space-md: 1rem;\n$space-sm: 0.5rem;\n$space-lg: 2rem;\n$border-width: 1.2px;\n\n#invoice {\n\tposition: fixed;\n\ttop: -100rem;\n\tleft: -100rem;\n\n\t& * {\n\t\ttext-transform: none !important;\n\t}\n}\n\n@mixin grid-row-column-spacing {\n\tgrid-column-gap: calc(3 * #{$space-md});\n\tgrid-row-gap: $space-lg;\n}\n\n.order-invoice-grid {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1.7fr;\n\tgrid-template-rows:\n\t\tcalc(1rem + #{$space-md}) 2rem minmax(calc(24 * #{$space-md}), auto)\n\t\tauto;\n\tgrid-column-gap: calc(3 * #{$space-md});\n\tgrid-row-gap: $space-lg;\n}\n.ordr-receipt-container-we {\n\theight: 100vh;\n\tcontain: content;\n}\n.A4Paper {\n\twidth: 794px;\n\theight: 1123px;\n\tpadding: 10rem 8rem 2rem 8rem;\n}\n.outline {\n\toutline: 1px solid black;\n}\n\n.A4-paper-container {\n\tline-height: 140%;\n\tfont-size: $font-md;\n}\n\n.div1 {\n\tgrid-area: 1 / 1 / 2 / 2;\n\twidth: 100%;\n\theight: 100%;\n\timg,\n\tsvg {\n\t\twidth: 100%;\n\t\ttranslate: 0% -52%;\n\t}\n}\n.div2 {\n\t// grid-area: 1 / 2 / 2 / 3;\n\n\tborder-top-style: solid;\n\tborder-bottom-style: solid;\n\tborder-color: $text-primary-color;\n\n\tborder-width: $border-width;\n\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\t// grid-column-gap: 0;\n\n\t& > :last-child {\n\t\tfont-weight: 500;\n\t\ttext-align: right;\n\t}\n}\n.ordr-invoice-header-title {\n\tdisplay: flex;\n\tflex-direction: column-reverse;\n\tfont-weight: $font-weight-strong;\n\ttranslate: 0 $space-md;\n\ttext-transform: none;\n}\n.ordr-invoice-section-title {\n\tfont-weight: $font-weight-bold;\n}\n.div3 {\n\tgrid-area: 2 / 1 / 3 / 3;\n}\n.div4 {\n\tgrid-area: 3 / 1 / 4 / 3;\n\tborder-top-style: solid;\n\tborder-width: $border-width;\n\n\t& > :last-child {\n\t\tpadding-top: $space-lg;\n\t}\n}\n.ordr-time-container {\n\tpadding-top: $space-md;\n\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1.7fr;\n\tgrid-column-gap: calc(3 * #{$space-md});\n\tgrid-row-gap: $space-sm;\n\n\t& > :nth-child(1) {\n\t\tgrid-area: 1 / 1 / 2 / 2;\n\t\tfont-weight: $font-weight-bold;\n\t\ttext-align: end;\n\t}\n\t& > :nth-child(2) {\n\t\tfont-weight: $font-weight-bold;\n\t\tgrid-area: 1 / 2 / 2 / 3;\n\n\t\t& > :last-child {\n\t\t\tpadding-left: 1.2ch;\n\t\t}\n\t}\n\t& > :nth-child(3) {\n\t\tgrid-area: 2 / 1 / 3 / 2;\n\t\ttext-align: end;\n\t}\n\t& > :nth-child(4) {\n\t\tgrid-area: 2 / 2 / 3 / 3;\n\t\t& > :last-child {\n\t\t\tpadding-left: 1.2ch;\n\t\t}\n\t}\n}\n.ordr-time-container-space {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 0.52fr;\n\tgrid-column-gap: calc(3 * #{$space-md});\n\tgrid-row-gap: $space-sm;\n\ttext-align: end;\n}\n\n.ordr-invoice-right-space {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr;\n\tgrid-row-gap: $space-sm;\n\ttext-align: start;\n\tposition: relative;\n}\n.ordr-dets-container {\n\tdisplay: grid;\n\tgrid-template-rows: minmax($space-md, auto);\n\tgrid-template-columns: 1fr 1.7fr;\n\tgrid-column-gap: calc(3 * #{$space-md});\n\tgrid-row-gap: $space-sm;\n\n\t&.space {\n\t\tgrid-template-columns: 1fr 0.52fr;\n\n\t\t& > :nth-child(even) {\n\t\t\ttext-align: end;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t& .tax-price {\n\t\t\tdisplay: flex;\n\t\t\talign-items: end;\n\t\t\tjustify-content: end;\n\t\t}\n\t}\n\n\t& > :nth-child(odd) {\n\t\ttext-align: end;\n\t}\n\n\t& > .ordr-dets-container-div1 {\n\t\tgrid-area: 1 / 1 / 2 / 2;\n\t}\n\t& > .ordr-dets-container-div2 {\n\t\tgrid-area: 1 / 2 / 2 / 3;\n\t}\n\t& > .ordr-dets-container-div3 {\n\t\tgrid-area: 2 / 1 / 3 / 2;\n\t}\n\t& > .ordr-dets-container-div4 {\n\t\tgrid-area: 2 / 2 / 3 / 3;\n\t}\n\t& > .ordr-dets-container-div5 {\n\t\tgrid-area: 3 / 1 / 4 / 2;\n\t}\n\t& > .ordr-dets-container-div6 {\n\t\tgrid-area: 3 / 2 / 4 / 3;\n\t}\n\t& > .ordr-dets-container-div7 {\n\t\tgrid-area: 4 / 1 / 5 / 2;\n\t}\n\t& > .ordr-dets-container-div8 {\n\t\tgrid-area: 4 / 2 / 5 / 3;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\t& > .ordr-dets-container-div9 {\n\t\tgrid-area: 5 / 2 / 6 / 3;\n\t}\n\t& > .ordr-dets-container-div10 {\n\t\tgrid-area: 6 / 1 / 7 / 2;\n\t}\n\t& > .ordr-dets-container-div11 {\n\t\tgrid-area: 6 / 2 / 7 / 3;\n\t}\n\t& > .ordr-dets-container-div12 {\n\t\tgrid-area: 7 / 1 / 8 / 2;\n\t}\n\t& > .ordr-dets-container-div13 {\n\t\tgrid-area: 7 / 2 / 8 / 3;\n\t}\n\t& > .ordr-dets-container-div14 {\n\t\tgrid-area: 8 / 1 / 9 / 2;\n\t}\n\t& > .ordr-dets-container-div15 {\n\t\tgrid-area: 8 / 2 / 9 / 3;\n\t}\n}\n.div5 {\n\tgrid-area: 4 / 1 / 5 / 2;\n}\n.div6 {\n\tgrid-area: 5 / 1 / 6 / 3;\n\tborder-top-style: solid;\n\tborder-width: $border-width;\n\n\tpadding-top: $space-md;\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 0.6fr;\n\tcolumn-gap: 1.5rem;\n}\n.div7 {\n\tgrid-area: 6 / 1 / 7 / 3;\n\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 0.6fr;\n\tcolumn-gap: 1.5rem;\n}\n.div8 {\n\tgrid-area: 7 / 1 / 8 / 3;\n\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 0.6fr;\n\tcolumn-gap: 1.5rem;\n}\n.div9 {\n\tgrid-area: 8 / 1 / 9 / 3;\n\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 0.6fr;\n\tcolumn-gap: 1.5rem;\n}\n\n.ordr-brand-address {\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n\tdisplay: flex;\n\tflex-direction: column;\n\ttext-align: end;\n\tpadding-bottom: 1rem;\n\tcolor: $text-primary-color;\n\t// font-size: medium;\n\twidth: 100%;\n}\n\n.ordr-total-container {\n\tborder-top-style: solid;\n\tborder-bottom-style: solid;\n\tborder-color: $text-primary-color;\n\n\tborder-width: $border-width;\n\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 0.5fr;\n\tgrid-column-gap: calc(3 * #{$space-md});\n\tgrid-row-gap: $space-sm;\n\tposition: relative;\n\n\ttranslate: 0 calc(-2 * #{$space-sm});\n\t& > * {\n\t\tpadding: calc(0.75 * #{$space-sm}) 0;\n\t}\n\t& > :first-child {\n\t\tfont-size: $font-weight-bold;\n\t\ttext-align: end;\n\t}\n\tpadding-right: 4px;\n}\n\n.tax-title-container {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
